import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const TILES = [
    { src: IMAGES.bridal, alt: "Acconciatura da sposa con fiori realizzata da Moovie Parrucchieri", cls: "col-span-2 md:col-span-5 aspect-[3/4]" },
    { src: IMAGES.postazioni, alt: "Le postazioni di lavoro del salone", cls: "col-span-2 md:col-span-7 aspect-[16/10]" },
    { src: IMAGES.zonaShampoo, alt: "La zona lavaggio del salone", cls: "col-span-1 md:col-span-4 aspect-[3/4]" },
    { src: IMAGES.wash, alt: "Momento dello shampoo e massaggio", cls: "col-span-1 md:col-span-4 aspect-[3/4]" },
    { src: IMAGES.prodotti, alt: "I prodotti professionali EKSperience in salone", cls: "col-span-2 md:col-span-4 aspect-[4/5] md:aspect-[3/4]" },
    { src: IMAGES.styling, alt: "Styling su capelli ramati", cls: "col-span-2 md:col-span-12 aspect-[16/8] md:aspect-[21/9]" },
];

const Gallery = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const driftA = useTransform(scrollYProgress, [0, 1], [30, -30]);
    const driftB = useTransform(scrollYProgress, [0, 1], [-20, 40]);

    return (
        <section
            id="galleria"
            ref={ref}
            data-testid="gallery-section"
            className="py-24 md:py-32 bg-sand overflow-hidden"
        >
            <div className="max-w-[1440px] mx-auto px-5 md:px-10">
                <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
                    <div>
                        <Overline>Galleria</Overline>
                        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                            I nostri <em className="italic text-rosegold">lavori</em>
                        </h2>
                    </div>
                    <p className="text-stone2 text-sm md:text-base max-w-xs">
                        Scorci del nostro salone e dei nostri lavori: postazioni,
                        zona lavaggio e i prodotti che usiamo ogni giorno.
                    </p>
                </Reveal>

                <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-6">
                    {TILES.map((t, i) => (
                        <motion.div
                            key={i}
                            data-testid={`gallery-image-${i + 1}`}
                            style={{ y: i % 3 === 0 ? driftA : i % 3 === 1 ? driftB : 0 }}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.1 }}
                            className={`group overflow-hidden border border-linen/70 ${t.cls}`}
                        >
                            <img
                                src={t.src}
                                alt={t.alt}
                                loading="lazy"
                                className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
                            />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Gallery;
